import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {RouterOutlet} from "@angular/router";
import {NgOptimizedImage} from "@angular/common";
import {HttpClientModule} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SpinnerComponent} from "./services/loader/spinner.component";
import {SafeHTMLPipe} from "./Pipes/SafeHTML.pipe";
import {NotfoundComponent} from "./pages/mainpages/notfound/notfound.component";
import {LoginComponent} from "./pages/mainpages/login/login.component";
import {JobsComponent} from "./pages/admin/jobs/jobs.component";
import {FilterkategorienComponent} from "./pages/admin/filterkategorien/filterkategorien.component";
import {JobFormComponent} from "./pages/admin/forms/jobform/jobform.component";
import {UserComponent} from "./pages/admin/user/user.component";
import {JobComponent} from "./pages/bewerber/job/job.component";
import {JobsucheComponent} from "./pages/bewerber/jobsuche/jobsuche.component";
import {AgbComponent} from "./pages/mainpages/agb/agb.component";
import {AnueComponent} from "./pages/mainpages/anue/anue.component";
import {DatenschutzComponent} from "./pages/mainpages/datenschutz/datenschutz.component";
import {GvpComponent} from "./pages/mainpages/gvp/gvp.component";
import {ImpressumComponent} from "./pages/mainpages/impressum/impressum.component";
import {KontaktComponent} from "./pages/mainpages/kontakt/kontakt.component";
import {StartseiteComponent} from "./pages/mainpages/startseite/startseite.component";
import {MitarbeitersucheComponent} from "./pages/unternehmen/mitarbeitersuche/mitarbeitersuche.component";
import {authInterceptorProviders} from "./Helper/auth.interceptor";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RecruitsComponent} from "./pages/admin/recruits/recruits.component";
import {RecruitformComponent} from "./pages/admin/forms/recruitform/recruitform.component";
import {EditorModule, TINYMCE_SCRIPT_SRC} from "@tinymce/tinymce-angular";
import {CustomersComponent} from "./pages/admin/customers/customers.component";
import {CustomerformComponent} from "./pages/admin/forms/customerform/customerform.component";
import {ContactsComponent} from "./pages/admin/contacts/contacts.component";
import {UserformComponent} from "./pages/admin/forms/userform/userform.component";
import {FilterformComponent} from "./pages/admin/forms/filterform/filterform.component";

@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
    LoginComponent,
    JobsComponent,
    JobComponent,
    JobsucheComponent,
    FilterkategorienComponent,
    JobFormComponent,
    SpinnerComponent,
    UserComponent,
    SafeHTMLPipe,
    AgbComponent,
    AnueComponent,
    DatenschutzComponent,
    GvpComponent,
    ImpressumComponent,
    KontaktComponent,
    StartseiteComponent,
    MitarbeitersucheComponent,
    RecruitsComponent,
    RecruitformComponent,
    CustomersComponent,
    CustomerformComponent,
    ContactsComponent,
    UserformComponent,
    FilterformComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterOutlet,
    HttpClientModule,
    NgOptimizedImage,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    FaIconComponent,
    EditorModule
  ],
  providers: [authInterceptorProviders, {provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
